import { useCallback, useRef, useState } from 'react'

export type UseCycleCamerasProps = {
  videoDeviceId?: string
  videoDeviceIds: string[]
  handleVideoDeviceChange: (deviceId: string) => void
}

export const useCycleCameras = ({
  videoDeviceId,
  videoDeviceIds,
  handleVideoDeviceChange,
}: UseCycleCamerasProps) => {
  const [toggled, setToggled] = useState<boolean>(false)
  const deviceIndexRef = useRef<number>(
    videoDeviceId ? videoDeviceIds?.indexOf(videoDeviceId) || 0 : 0,
  )

  const onClick = useCallback(() => {
    deviceIndexRef.current =
      (deviceIndexRef.current + 1) % videoDeviceIds.length
    handleVideoDeviceChange(videoDeviceIds[deviceIndexRef.current])
    setToggled((s) => !s)
  }, [handleVideoDeviceChange, videoDeviceIds])

  return {
    toggled,
    onClick,
  }
}
